module.exports = __webpack_public_path__ + "static/complex_02-9edcd3069ac15551a51491fb086f1c40.png";